var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 25,
    viewBox: "0 0 15 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.945312 23.1602L13.4453 21.6602",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4219 0.0800781V1.68066H14.0254V2.63672H12.4219V4.24023H11.4658V2.63672H9.86523V1.68066H11.4658V0.0800781H12.4219Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.16
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.951172 19.1604V3.8877H6.79776C7.90146 3.8877 8.81871 4.0617 9.54954 4.40971C10.2853 4.75275 10.8347 5.22257 11.1976 5.81916C11.5655 6.41575 11.7495 7.09189 11.7495 7.84757C11.7495 8.46902 11.6301 9.00098 11.3915 9.44345C11.1529 9.88095 10.8322 10.2364 10.4295 10.5099C10.0268 10.7833 9.57688 10.9797 9.07972 11.099V11.2481C9.62163 11.278 10.1412 11.4445 10.6383 11.7478C11.1404 12.0461 11.5506 12.4687 11.8688 13.0155C12.187 13.5624 12.3461 14.2236 12.3461 14.9992C12.3461 15.7897 12.1547 16.5006 11.7718 17.132C11.389 17.7584 10.8123 18.2531 10.0417 18.616C9.27113 18.979 8.30167 19.1604 7.13335 19.1604H0.951172ZM3.71786 16.8486H6.69336C7.69762 16.8486 8.42099 16.6572 8.86346 16.2744C9.3109 15.8866 9.53462 15.3895 9.53462 14.7829C9.53462 14.3305 9.42276 13.9229 9.19904 13.5599C8.97532 13.192 8.65714 12.9037 8.2445 12.6949C7.83185 12.4811 7.33967 12.3742 6.76793 12.3742H3.71786V16.8486ZM3.71786 10.3831H6.45472C6.932 10.3831 7.36204 10.2961 7.74485 10.1221C8.12766 9.94309 8.42844 9.69203 8.64719 9.36887C8.87092 9.04075 8.98278 8.65297 8.98278 8.20552C8.98278 7.6139 8.77397 7.12669 8.35636 6.74387C7.94372 6.36106 7.32972 6.16966 6.51438 6.16966H3.71786V10.3831Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBPlus);
export default __webpack_public_path__ + "static/media/b-plus.ab53ba03caba56fe76ca5a5502a243cb.svg";
export { ForwardRef as ReactComponent };